import { render, staticRenderFns } from "./ScoringCode.vue?vue&type=template&id=352d2aed&"
import script from "./ScoringCode.js?vue&type=script&lang=js&"
export * from "./ScoringCode.js?vue&type=script&lang=js&"
import style0 from "./ScoringCode.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VFileInput,VLabel,VTextField})
